import { render, staticRenderFns } from "./v005_registerItem.vue?vue&type=template&id=7a45b0b3&scoped=true&"
import script from "./v005_registerItem.vue?vue&type=script&lang=js&"
export * from "./v005_registerItem.vue?vue&type=script&lang=js&"
import style0 from "./v005_registerItem.vue?vue&type=style&index=0&id=7a45b0b3&scoped=true&lang=scss&"
import style1 from "./v005_registerItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45b0b3",
  null
  
)

export default component.exports